module.exports = __webpack_public_path__ + "img/logo_white_new@2x.a1ce08c9.png";